import { api } from "@/lib/api";
export default api;
